// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import Alpine from 'alpinejs'

window.Alpine = Alpine
 
Alpine.start()

require('fslightbox');

const swipers = document.getElementsByClassName('swiper-container');
let swipersArray = Array.from(swipers);

//Remove header slider from array because it does not have a thumbs navigation
for (let i = 0; i < swipersArray.length; i++) {
	if (swipersArray[i].getAttribute('id') == 'headerSlider') {
		let headerSlider = swipersArray[i];
		headerSlider.classList.add('swiper-container-header');
		//Initialize header slider separately
		if (headerSlider) {
			const classes = headerSlider.getAttribute("class");
			if (classes.includes('noautoslide')) {
				const noautoslideSwiper = new Swiper('.swiper-container-header', {
					modules: [Navigation],
					
					// Optional parameters
					speed: 1000,
					loop: true,

					// Navigation arrows
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}

				})
			} else {
				const autoslideSwiper = new Swiper('.swiper-container-header', {
					modules: [Navigation, Autoplay],

					autoplay: {
						delay: 5000,
					},
			
					// Optional parameters
					speed: 1000,
					loop: true,
			
					// Navigation arrows
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					}
				})
			}
		}

		swipersArray.splice(swipersArray[i], 1);
	}
}

const swiperNavs = document.getElementsByClassName('swiper-navigation');

for (let i = 0; i < swipersArray.length; i++) {
	swipersArray[i].classList.add('swiper-container-' + i);
	swiperNavs[i].classList.add('swiper-navigation-' + i);

	let swiperNav = swiperNavs[i];
	let swiperNavCount = swiperNav.getElementsByClassName('swiper-navigation__navitem').length;
	const navSwiper = new Swiper('.swiper-navigation-' + i, {
		modules: [FreeMode],
		spaceBetween: 5,
		slidesPerView: 5,
		freeMode: true,
		watchSlidesProgress: true,
	});

	let swiperNoAutoslide = swipersArray[i];
	if(swiperNoAutoslide != null){
		const classes = swipersArray[i].getAttribute("class");
		if (classes.includes('noautoslide')) {
			const noautoslideSwiper = new Swiper('.swiper-container-' + i, {
				modules: [Navigation, Thumbs],
				
				// Optional parameters
				speed: 1000,
				loop: true,
	
				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
	
				thumbs: {
					swiper: navSwiper,
					autoScrollOffset: 1,
				},
	
			})
		} else {
			const autoslideSwiper = new Swiper('.swiper-container-' + i, {
				modules: [Navigation, Thumbs, Autoplay],

				autoplay: {
					delay: 5000,
				},
		
				// Optional parameters
				speed: 1000,
				loop: true,
		
				// Navigation arrows
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},

				thumbs: {
					swiper: navSwiper,
				},
			})
		}
	}
}

// default nav
var mainNavs = document.getElementsByClassName('m-mainnav');
var mainNavsCount = mainNavs.length;
if(mainNavs != null){
	for( var n = 0, mainNavsCount; n < mainNavsCount; n++ ){
		var currentNav = mainNavs[n];
		var navItems = mainNavs[n].getElementsByClassName('m-mainnav__listitem--has-children');
		var navItemsCount = navItems.length;
		if(navItems != null && navItemsCount > 0){
			for( var i = 0; i < navItemsCount; i++ ){
				navItems[i].firstElementChild.onclick = function(e){
					e.preventDefault();
					closeNavitems();
					this.classList.toggle('is-clicked');
					this.nextElementSibling.classList.toggle('is-visible');
				}
			}
		}
	}
}

function closeNavitems(){
	var clickedLinks = currentNav.getElementsByClassName('is-clicked');
	var clickedLinksCount = clickedLinks.length;
	var visibleChildren = currentNav.getElementsByClassName('is-visible');
	for( var y = 0, clickedLinksCount; y < clickedLinksCount; y++ ){  
		clickedLinks[y].classList.remove('is-clicked');
		visibleChildren[y].classList.remove('is-visible');
	}
}

// mobile nav
var hamburger = document.getElementById('hamburger');
var nav = document.getElementById('mainnav');
if(hamburger != null && nav != null){
	hamburger.onclick = function(e){
		hamburger.classList.toggle('is-clicked');
		nav.classList.toggle('is-visible');
	}
}

// Update aria-expanded attributes on submenus
if (mainNavs != null) {
	for (let i = 0; i < mainNavsCount; i++) {
		//Default nav with hover
		if (mainNavs[i].id == 'mainnavDefault') {

			const navitemsWithChildren = mainNavs[i].querySelectorAll('.m-mainnav__listitem--has-children');

			navitemsWithChildren.forEach(element => {
				const child = element.querySelector('.m-mainnav__listitem-link');
				element.addEventListener("mouseenter", function() {
					element.setAttribute('aria-expanded', 'true');
				})
				element.addEventListener("mouseleave", function() {
					if (element.getAttribute('aria-expanded') && child.classList.contains('is-clicked')) {
						//Submenu is open through click, it stays open when moving the mouse out of it.			
					} else {
						element.setAttribute('aria-expanded', 'false');
					}
				})
				element.addEventListener("click", function() {
					if (element.getAttribute('aria-expanded') == 'false') {
						element.setAttribute('aria-expanded', 'true');
					} else if(element.getAttribute('aria-expanded') == 'true') {
						if (!child.classList.contains('is-clicked')) { //classList is updated first, so we check if is-clicked is missing instead.
							element.setAttribute('aria-expanded', 'false');
						}
					} else {
						//Submenu is open through hover, it stays open when clicked.
					}
				})
			});

		//Hamburger nav
		} else if (mainNavs[i].id == 'mainnav') {

			const navitemsWithChildren = mainNavs[i].querySelectorAll('.m-mainnav__listitem--has-children');

			navitemsWithChildren.forEach(element => {
				const child = element.querySelector('.m-mainnav__listitem-link');
				element.addEventListener("click", function() {
					navitemsWithChildren.forEach(otherElement => {
						otherElement.setAttribute('aria-expanded', 'false');
					})
					element.setAttribute('aria-expanded', 'true');
				})
			})

		}
	}
}

// check if form buttons are manually triggered, or not (spam check)
var submitButtons = document.getElementsByClassName('m-form__submit');
var submitButtonsCount = submitButtons.length;
if(submitButtons != null && submitButtonsCount > 0){
	for( var b = 0; b < submitButtonsCount; b++ ){
		submitButtons[b].onclick = function(e){
			if(e.isTrusted){
				// Manually triggered
				return true;
			} else {
				return false; 
			}
		}
	}
}

// close interferrer
const interferrerButton = document.getElementById('closeInterferrer');
const interferrer = document.getElementById('interferrer');

if (interferrer) {
	let state = sessionStorage.getItem("interferrer")

	if (state === 'closed') {
		interferrer.classList.add('is-hidden');
		interferrerButton.classList.add('is-closed');
	} else {
		interferrer.classList.add('is-visible');
		interferrerButton.classList.add('is-open');
	}

	interferrerButton.addEventListener("click", function() {
		state = sessionStorage.getItem("interferrer");
		interferrer.classList.toggle('is-visible');
		interferrer.classList.toggle('is-hidden');
		interferrerButton.classList.toggle('is-closed');
		interferrerButton.classList.toggle('is-open');
		if (state === 'closed') {
			sessionStorage.setItem("interferrer", "open");
		} else {
			sessionStorage.setItem("interferrer", "closed");
		}
	})
}

/**
 * Combined form
 */

const contactFormBtn = document.getElementById('toggleContactForm');
const offerFormBtn = document.getElementById('toggleOfferForm');

let currentlyActive = sessionStorage.getItem('activeForm');

if (contactFormBtn && offerFormBtn) {
	const contactForm = document.getElementById('form-1');
	const offerForm = document.getElementById('form-2');

	if (currentlyActive === 'offerForm') {
		contactForm.classList.remove('visible');
		contactFormBtn.classList.remove('active');
		offerForm.classList.add('visible');
		offerFormBtn.classList.add('active');
	} else if (currentlyActive === 'contactForm') {
		offerForm.classList.remove('visible');
		offerFormBtn.classList.remove('active');
		contactForm.classList.add('visible');
		contactFormBtn.classList.add('active');
	}

	offerFormBtn.addEventListener("click", () => {
		contactForm.classList.remove('visible');
		contactFormBtn.classList.remove('active');
		offerForm.classList.add('visible');
		offerFormBtn.classList.add('active');
		sessionStorage.setItem('activeForm', 'offerForm');
	})

	contactFormBtn.addEventListener("click", () => {
		offerForm.classList.remove('visible');
		offerFormBtn.classList.remove('active');
		contactForm.classList.add('visible');
		contactFormBtn.classList.add('active');
		sessionStorage.setItem('activeForm', 'contactForm');
	})
}

const bookingbarOfferBtn = document.getElementById('bookingbarOfferBtn');

if (bookingbarOfferBtn) {
	bookingbarOfferBtn.addEventListener("click", () => {
		let arrival = document.getElementById('arrival').value;
		let departure = document.getElementById('departure').value;
		let adults = document.getElementById('adults').value;
		let children = document.getElementById('children').value;
		let slug = bookingbarOfferBtn.getAttribute('data-slug');

		window.location.href = slug+'/?form=offer&arrival='+arrival+'&departure='+departure+'&adults='+adults+'&children='+children+'#kontaktformular';
	})
}

/**
 * Booking functions
 */

//Do not allow past dates in offerform/bookingbar date pickers
const arrivalInput = document.getElementById('arrival');
const departureInput = document.getElementById('departure');
if (arrivalInput && departureInput) {
	let dateToday = new Date();
	dateToday = dateToday.toLocaleDateString('en-CA', { timeZone: "Europe/Zurich"}); //en-CA uses yyyy-mm-dd format, which is required for the "min" attribute
	arrivalInput.setAttribute('min', dateToday);
	departureInput.setAttribute('min', dateToday);
}

const bookingBtn = document.getElementById('bookingbarBookingBtn');

// Simplebooking
// https://www.simplebooking.it/ibe/hotelbooking/search?hid=5643&lang=DE#/q&guests=A,A,1&in=2019-10-10&out=2019-10-18&coupon=

// Tbooking
// https://tbooking.toubiz.de/TDS00020010350054462/tbooking/?doSearch=1&globalReset=1&lang=de&date_from=24.01.2025&date_to=26.01.2025&number_adult[0]=2&number_child[0]=1

if (bookingBtn) {

	bookingBtn.addEventListener("click", handleBookingForm);
	function handleBookingForm() {
		const bookingTool = bookingBtn.getAttribute('data-bookingtool');

		let arrival = document.getElementById('arrival').value;
		let departure = document.getElementById('departure').value;
		let adults = document.getElementById('adults').value;
		let children = document.getElementById('children').value;
		let language = bookingBtn.getAttribute('data-lang');
		language = language.split('_')[0];

		if (bookingTool === 'simplebooking') {

			const simplebookingID = bookingBtn.getAttribute('data-id');

			let guests = [];

			// Convert number of adults to "a" for each adult
			if (adults > 0) {
				for (var i=0; i < adults; i++) {
					guests.push('A');
				}
			}

			// Convert number of children to age of "14" for each child
			if (children > 0) {
				for (var i=0; i < children; i++) {
					guests.push('14');
				}
			}

			guests.join(',');

			let simplebookingParams = simplebookingID + '/?';
			
			simplebookingParams += '&lang=' + language;
			simplebookingParams += '&cur=CHF';
			simplebookingParams += '&guests=' + guests;
			simplebookingParams += '&in=' + arrival;
			simplebookingParams += '&out=' + departure;

			//console.log('https://www.simplebooking.it/ibe2/hotel/' + simplebookingParams);
			
			window.open('https://www.simplebooking.it/ibe2/hotel/' + simplebookingParams);

		} else if (bookingTool === 'tbooking') {
			
			const tbookingID = bookingBtn.getAttribute('data-id');
			let arrivalDate = new Date(arrival);
			let departureDate = new Date(departure);
			let arrivalFormatTbooking = '';
			let departureFormatTbooking = '';

			// Check for valid arrival date
			if (Object.prototype.toString.call(arrivalDate) === "[object Date]") {
				if (!isNaN(arrivalDate.getTime())) {
					arrivalFormatTbooking = ('0' + arrivalDate.getDate()).slice(-2) + '.' + ('0' + (arrivalDate.getMonth()+1)).slice(-2) + '.' + arrivalDate.getFullYear();
				}
			}

			// Check for valid departure date
			if (Object.prototype.toString.call(departureDate) === "[object Date]") {
				if (!isNaN(departureDate.getTime())) {
				departureFormatTbooking = ('0' + departureDate.getDate()).slice(-2) + '.' + ('0' + (departureDate.getMonth()+1)).slice(-2) + '.' + departureDate.getFullYear();
				}
			}

			// Initial
			var tbookingParams = '?doSearch=1&globalReset=1';
			// Language
			tbookingParams += '&lang=' + language;
			// Arrival
			tbookingParams += '&date_from=' + arrivalFormatTbooking;
			// Departure
			tbookingParams += '&date_to=' + departureFormatTbooking;
			// Adults
			tbookingParams += '&number_adult[0]=' + adults;
			// Children
			tbookingParams += '&number_child[0]=' + children;

			window.open('https://tbooking.toubiz.de/' + tbookingID + '/tbooking/' + tbookingParams);

		} else if (bookingTool === 'spiderbooking') {
			let spiderbookingUrl = bookingBtn.getAttribute('data-id');

			// Language
			var spiderbookingParams = '?lang=' + language;
			// Adults
			spiderbookingParams += '&nbAdults=' + adults;
			// Children
			spiderbookingParams += '&nbChildren=' + children;
			// Check in
			spiderbookingParams += '&checkIn=' + arrival;
			// Check out
			spiderbookingParams += '&checkOut=' + departure;

			console.log(spiderbookingUrl + spiderbookingParams);
			
			window.open(spiderbookingUrl + spiderbookingParams);

		} else if (bookingTool === 'dirs21') {
			let dirs21Url = bookingBtn.getAttribute('data-id');

			if (language === 'de') {
				language = 'de-DE';
			} else if (language === 'en') {
				language = 'en-GB';
			} else {
				language = '';
			}

			let room = [];

			// Convert number of adults to "a" for each adult
			if (adults > 0) {
				for (var i = 0; i < adults; i++) {
				room.push('a');
				}
			}
		
			// Convert number of cildren to age of "6" for each child
			if (children > 0) {
				for (var i = 0; i < children; i++) {
				room.push('6');
				}
			}

			room.join(',');

			// Initial & language
			var dirs21Params = '?culture=' + language;
			// Arrival
			dirs21Params += '&arrival=' + arrival;
			// Departure
			dirs21Params += '&departure=' + departure;
			// Adults & Children
			dirs21Params += '&room=' + room;

			window.open(dirs21Url + dirs21Params);

		}
	}
}

//Custom play/pause for header video, we need to be able to pause the video for accessibility reasons, but without showing the default controls.
const headerVideo = document.getElementById('headerVideo');
if (headerVideo) {
	headerVideo.addEventListener("click", function() {
		if (headerVideo.paused) {
			headerVideo.play();
		} else {
			headerVideo.pause();
		}
	})
}